export function titleCase(str) {
  if (!str || !str.length) {
    return '';
  }
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

export function titleCaseSnakeCasing(str) {
  if (!str || !str.length) {
    return '';
  }
  var splitStr = str.toLowerCase().split('_');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

export const formatDate = (date, withoutUnderscore = false) => {
  let today: any = new Date(date);
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  let dd: any = today.getDate();
  let mm: any = today.getMonth() + 1;

  let yyyy = today.getFullYear();

  today = withoutUnderscore
    ? dd + ' ' + monthNames[mm - 1] + ' ' + yyyy
    : dd + '_' + monthNames[mm - 1].toLocaleLowerCase() + '_' + yyyy;
  return today;
};

export const getDateInDDMMYYYY = date => {
  let today: any = new Date(date);

  let dd: any = today.getDate();
  let mm: any = today.getMonth() + 1;

  let yyyy = today.getFullYear();

  today = dd + '-' + mm + '-' + yyyy;
  return today;
};
